import { apiService } from './apiService';

export const automationService = {
  async getAll() {
    return await apiService.get('/automations');
  },

  async getRuns(automationId?: string | number) {
    const query = automationId ? `?automationId=${encodeURIComponent(String(automationId))}` : '';
    return await apiService.get(`/automations/runs${query}`);
  },

  async getTemplateVariables(entityType: string) {
    const query = `?entityType=${encodeURIComponent(entityType)}`;
    return await apiService.get(`/automations/template-variables${query}`);
  },

  async create(data: any) {
    return await apiService.post('/automations', data);
  },

  async update(id: string | number, data: any) {
    return await apiService.put(`/automations/${id}`, data);
  },

  async delete(id: string | number) {
    return await apiService.delete(`/automations/${id}`);
  },

  async testRun(data: { actions: any[]; conditions?: any[]; context?: any }) {
    return await apiService.post('/automations/test-run', data);
  },
};
